import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-ab-unknown',
  templateUrl: './ab-unknown.component.html',
  styleUrls: ['./ab-unknown.component.scss']
})
export class AbUnknownComponent implements OnInit {

 @Input() element: any;

  constructor() { }

  ngOnInit(): void {
  }

}
